import { createFileRoute } from '@tanstack/react-router';
import { TemplatesScreen } from '../../../features/templates/templates-screen';

export const Route = createFileRoute('/_authenticated/template-uri/')({
  component: TemplatesScreen,
});
